import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

import mascot from 'assets/Images/myriad-motion/mascot.png';

const STEPS = [
  { name: 'HIPAA Consent', status: 'done' },
  { name: 'Insurance', status: 'done' },
  { name: 'Personal ID', status: 'done' },
  { name: 'Personal info', status: 'todo' },
  { name: 'Past forms', status: 'todo' },
  { name: 'Secure payment', status: 'active' }
];

// Static stand-in for the shared `StepperSidebar` the check-in wizard renders beside the step.
const CheckinSidebarPreview = () => (
  <aside className="sticky top-5 flex w-80 shrink-0 flex-col gap-4 self-start">
    <div className="flex flex-col overflow-hidden rounded-xl bg-white">
      <div className="p-4">
        <Icon icon="logo" />
      </div>
      <ul className="m-0 flex list-none flex-col gap-2 px-4 pb-4">
        {STEPS.map((step, index) => {
          const isDone = step.status === 'done';
          const isActive = step.status === 'active';
          const isLast = index === STEPS.length - 1;
          return (
            <li
              key={step.name}
              className={cn(
                'rounded-xl border border-solid border-transparent px-3 py-2',
                isActive && 'border-primary-200 bg-primary-25'
              )}>
              <div className="relative flex items-center gap-3">
                {index > 0 && (
                  <span className="absolute left-3 top-[-20px] h-8 w-px bg-neutral-200" />
                )}
                {!isLast && (
                  <span className="absolute bottom-[-20px] left-3 top-3 w-px bg-neutral-200" />
                )}
                <span
                  className={cn(
                    'relative z-10 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-solid bg-white text-xs font-500 leading-none',
                    isDone
                      ? 'border-success-500 bg-success-500 text-white'
                      : isActive
                        ? 'border-primary-500 bg-primary-500 text-[color:var(--color-on-primary,#fff)]'
                        : 'border-primary-500 text-primary-500'
                  )}>
                  {index + 1}
                </span>
                <span
                  className={cn(
                    'min-w-0 flex-1 truncate text-sm font-500 text-neutral-900',
                    isActive && 'font-600 text-primary-500'
                  )}>
                  {step.name}
                </span>
                {isDone && <Icon icon="check-linear" color="success" size={14} />}
              </div>
            </li>
          );
        })}
      </ul>
    </div>

    <div className="flex h-[252px] flex-col justify-between rounded-xl bg-white px-4 py-2">
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-between gap-1">
          <div className="flex min-w-0 items-center gap-1">
            <img src={mascot} alt="" className="h-10 w-10 shrink-0 object-contain" />
            <p className="truncate text-xs font-600">Myriad smart suggestions</p>
          </div>
          <div className="flex shrink-0 gap-1">
            <span className="rounded border border-solid border-neutral-200">
              <Icon icon="chevron-left-linear" />
            </span>
            <span className="rounded border border-solid border-neutral-200">
              <Icon icon="chevron-right-linear" />
            </span>
          </div>
        </div>
        <p className="text-sm text-neutral-800">Add users who need access to your practice.</p>
      </div>
      <div className="flex justify-center">
        <Icon icon="carousel-dot-1" />
      </div>
    </div>

    <div className="flex items-center justify-between gap-2 rounded-xl bg-white px-4 py-1.5">
      <p className="text-xs">Get assistance whenever you need it.</p>
      <div className="flex shrink-0 gap-1">
        <Icon icon="call-calling-mono" color="primary" size={20} />
        <Icon icon="intercom-mono" size={20} />
      </div>
    </div>
  </aside>
);

export default CheckinSidebarPreview;
